import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ConfigCtx = createContext({ config: {}, refresh: () => {} });

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    whatsapp_number: "50686686644",
    messages: {
      default: "Hola, me interesa más información sobre el catálogo.",
      product: "Hola, me interesa información sobre {product}.",
      kit: "Hola, me interesa el kit {kit} (pedido especial).",
      contact: "Hola, me gustaría hacer una consulta general.",
    },
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config");
      if (data && data.whatsapp_number) setConfig(data);
    } catch (err) {
      console.warn("[config] /config fetch failed, using defaults:", err?.message);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <ConfigCtx.Provider value={{ config, refresh }}>{children}</ConfigCtx.Provider>;
};

export const useConfig = () => useContext(ConfigCtx);

export const buildWhatsAppUrl = (number, message) => {
  const clean = (number || "50686686644").replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(message || "Hola, me interesa más información sobre el catálogo.")}`;
};
